var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconImage24(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.714 8.786a1.929 1.929 0 100 3.857 1.929 1.929 0 000-3.857zm-.929 1.928a.929.929 0 111.858 0 .929.929 0 01-1.858 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.429 18.357h.24A2.5 2.5 0 008.142 20.5H17a2.5 2.5 0 002.5-2.5V9.143a2.5 2.5 0 00-2.143-2.475v-.24A1.929 1.929 0 0015.43 4.5h-10A1.929 1.929 0 003.5 6.429v10c0 1.065.863 1.928 1.929 1.928zm0-12.857a.929.929 0 00-.929.929v10c0 .512.416.928.929.928h.214V9.143a2.5 2.5 0 012.5-2.5h8.214v-.214a.929.929 0 00-.928-.929h-10zm1.214 3.643a1.5 1.5 0 011.5-1.5H17a1.5 1.5 0 011.5 1.5v7.042l-2.67-2.95a.5.5 0 00-.723-.019l-3.295 3.267-2.511-1.893a.5.5 0 00-.655.047l-2.003 2.01V9.143zm.001 8.92A1.5 1.5 0 008.143 19.5H17a1.5 1.5 0 001.5-1.5v-.325l-3.06-3.38-3.231 3.203a.5.5 0 01-.653.044l-2.51-1.89-2.402 2.41z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconImage24);
export default __webpack_public_path__ + "static/media/icon-image-24.80e66f5b.svg";
export { ForwardRef as ReactComponent };